<template>
  <div>
    <slot>
      <h2 v-if="showTitle " class="title is-4 m-t-20">{{ question.question }}</h2>
    </slot>
    <div class="buttons m-t-30">
      <div
        v-for="option in options"
        :key="option"
        @click="startSaveFeedback(option, $event)"
        :class="[buttonClass]"
        class="button is-fullwidth"
      >
        {{ option }}
      </div>

      <template v-if="includeOther">
        <div v-if="!respondOther" @click="respondOther = true" :class="[buttonClass]" class="button is-fullwidth">Other</div>
        <b-field v-else style="width: 100%" expanded>
          <b-input v-model="responseText" :placeholder="otherText" type="text" expanded />
          <p class="control">
            <b-button @click="startSaveFeedback(responseText, $event)" class="button is-primary">{{ otherButton }}</b-button>
          </p>
        </b-field>
      </template>
    </div>
  </div>
</template>

<script>
import { getQuestion, insertFeedback } from '~/queries/feedback.gql'
export default {
  props: {
    questionId: {
      type: Number,
      default: null,
      required: true
    },
    options: {
      type: Array,
      default: () => []
    },
    includeOther: {
      type: Boolean,
      default: false,
      required: false
    },
    otherButton: {
      type: String,
      default: 'Next'
    },
    otherText: {
      type: String,
      default: 'Enter your answer'
    },
    showTitle: { default: true },
    buttonClass: { default: '' }
  },
  data () {
    return {
      respondOther: false,
      responseText: '',
      question: {}
    }
  },
  apollo: {
    question: {
      query: getQuestion,
      variables () {
        return {
          id: this.questionId
        }
      },
      update (data) {
        console.log(data)
        return data.feedbackQuestions_by_pk
      }
    }
  },
  mounted () {

  },
  methods: {
    async startSaveFeedback (feedback, event) {
      event.target.classList.add('is-loading')
      await this.saveFeedback(feedback)
      event.target.classList.remove('is-loading')
      this.$emit('next', feedback)
    },
    async saveFeedback (feedback) {
      await this.$apollo.mutate({
        mutation: insertFeedback,
        variables: {
          response: feedback,
          questionId: this.questionId,
          userId: this.$auth.user ? this.$auth.user.id : null,
          questionText: this.question.question,
          url: process.env.SITE_URL + this.$route.path
        }
      })
    }
  }
}
</script>
